import StyledButton from 'components/Elements/StyledButton'
import { Carousel, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'
import { colors } from 'style'
import { StandardsContainer } from './style'

function Standards() {
  const { t } = useTranslation()
  const history = useHistory()

  const features = [
    {
      img: 'book',
      title: t('standard_item1_title'),
      description: t('standard_item1_description'),
    },
    {
      img: 'group_add',
      title: t('standard_item2_title'),
      description: t('standard_item2_description'),
    },
    {
      img: 'auto_stories',
      title: t('standard_item3_title'),
      description: t('standard_item3_description'),
    },
    {
      img: 'dashboard',
      title: t('standard_item4_title'),
      description: t('standard_item4_description'),
    },
    {
      img: 'publish',
      title: t('standard_item5_title'),
      description: t('standard_item5_description'),
    },
    {
      img: 'brush',
      title: t('standard_item6_title'),
      description: t('standard_item6_description'),
    },
    {
      img: 'calendar_month',
      title: t('standard_access_title'),
      description: t('standard_access_description'),
    },
    {
      img: 'auto_stories',
      title: t('standard_color_title'),
      description: t('standard_color_description'),
    },
    {
      img: 'content_copy',
      title: t('standard_copies_title'),
      description: t('standard_copies_description'),
    },
    {
      img: 'local_shipping',
      title: t('standard_shipping_title'),
      description: t('standard_shipping_description'),
    },
    {
      img: 'cloud_download',
      title: t('standard_digidownload_title'),
      description: t('standard_digidownload_description'),
    },
    {
      img: 'mood',
      title: t('standard_support_title'),
      description: t('standard_support_description'),
    },
  ]
  return (
    <StandardsContainer>
      <Container className="h-100">
        <h1 className="standards-header-title">Price includes</h1>
        <Row className="standards-wrapper">
          {features.map((_feature, _i) => (
            <Col key={_i} md={4}>
              <div className="standard-item">
                <div className="standard-item-title">
                  <span className="material-icons-outlined icon">
                    {_feature.img}
                  </span>
                  <h3>{_feature.title}</h3>
                </div>
                <h4>{_feature.description}</h4>
              </div>
            </Col>
          ))}
        </Row>
        <Carousel
          className="standards-wrapper-sm"
          nextIcon={<FaAngleRight color={colors.white} />}
          prevIcon={<FaAngleLeft color={colors.white} />}
          interval={500000}
        >
          {features.map((_feature, _i) => (
            <Carousel.Item key={_i}>
              <div key={_i} className="roadblock-item">
                <div className="img-wrapper d-flex align-items-start title">
                  <span className="material-icons-outlined icon">
                    {_feature.img}
                  </span>
                  <h3 className="ml-2">{_feature.title}</h3>
                </div>
                <div className="roadblock-content mt-3">
                  <h4>{_feature.description}</h4>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>

        <div className="btn-wrapper">
          <StyledButton
            className="btn-blue btn-get-started"
            title={t('getstarted')}
            onClick={() => history.push('/get-started')}
          />
        </div>
      </Container>
    </StandardsContainer>
  )
}

export default Standards
